module.exports = " <span v-el:trigger> <slot> </slot> </span> <div class=popover v-bind:class=\"{\n  'top':placement === 'top',\n  'left':placement === 'left',\n  'right':placement === 'right',\n  'bottom':placement === 'bottom'\n  }\" v-el:popover v-show=show :transition=effect> <div class=arrow></div> <h3 class=popover-title v-show=title>{{title}}</h3> <div class=popover-content> {{{content}}} </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/_vue-html-loader@1.2.4@vue-html-loader!./~/_vue-loader@8.3.1@vue-loader/lib/selector.js?type=template&index=0!./bootsets/components/vue-strap/Popover.vue
// module id = 260
// module chunks = 0